import { AbstractService } from '@shared/abstract.service';
import { SERVICES, HTTP_METHODS } from '@root/constant';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../shared/encryption.service";
const URL = SERVICES.LOGIN.PATH;
export class LoginService extends AbstractService {
    constructor(http, encryptionProviderService) {
        super(http, URL, encryptionProviderService);
        this.encryptionProviderService = encryptionProviderService;
    }
    login(data) {
        const url = SERVICES.LOGIN.PATH;
        return this.request({
            method: HTTP_METHODS.POST,
            url: `${url}`,
            body: data,
        });
    }
    logout() {
        const url = SERVICES.LOGOUT.PATH;
        return this.request({
            method: HTTP_METHODS.POST,
            url: `${url}`,
            body: {}
        });
    }
}
LoginService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function LoginService_Factory() { return new LoginService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.EncryptionProviderService)); }, token: LoginService, providedIn: "root" });
